export const getMapDimensions = /* istanbul ignore next */ (state) => state.mapDimensions;
